import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Functions, httpsCallableData } from '@angular/fire/functions';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

@Component({
  selector: 'app-linkedin-signin',
  templateUrl: './linkedin-signin.component.html',
  styleUrls: ['./linkedin-signin.component.sass']
})
export class LinkedinSigninComponent implements OnInit {

  private authUrl = 'https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=78mopcyobf9xwi&redirect_uri=https://localhost:4200/authentication/linkedin/callback&state=DCEeFWf45A53sdfKef424&scope=r_liteprofile';
  isUserAuthenticated = false;
  authorizationCode: string;
  oAuthToken: string;
  oAuthVerifier: string;
  // popup related
  private windowHandle: Window;   // reference to the window object we will create    
  private intervalId: any = null;  // For setting interval time between we check for authorization code or token
  private loopCount = 600;   // the count until which the check will be done, or after window be closed automatically.
  private intervalLength = 100;   // the gap in which the check will be done for code.
  constructor(private window: Window, private fns: Functions, private http: HttpClient) { }

  ngOnInit(): void {

  }

  doAuthorization() {
    /* isRegisterAction flag i am using to check if the process is for registration or Login */
    /* socialMediaProvider is for name of social media , it is optional*/

    let loopCount = this.loopCount;

    /* Create the window object by passing url and optional window title */
    this.windowHandle = this.createOauthWindow();

    /* Now start the timer for which the window will stay, and after time over window will be closed */
    this.intervalId = window.setInterval(() => {
      if (loopCount-- < 0) {
        window.clearInterval(this.intervalId);
        this.windowHandle.close();
      } else {
        let href: string;  // For referencing window url
        try {
          href = this.windowHandle.location.href; // set window location to href string
        } catch (e) {
          // console.log('Error:', e); // Handle any errors here
        }
        if (href != null) {

          // Method for getting query parameters from query string
          const getQueryString = function (field: any, url: string) {
            const windowLocationUrl = url ? url : href;
            const reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
            const string = reg.exec(windowLocationUrl);
            return string ? string[1] : null;
          };
          /* As i was getting code and oauth-token i added for same, you can replace with your expected variables */
          if (href.match('code')) {
            // for google , fb, github, linkedin
            window.clearInterval(this.intervalId);
            this.authorizationCode = getQueryString('code', href);
            const state = getQueryString('state', href);
            console.log('LINKED IN DATA ', this.authorizationCode, ', ', state);
            this.getLinkedInAccessToken(this.authorizationCode);
            this.windowHandle.close();
            if (this.authorizationCode) {
              //this.isUserAuthenticated = true;
            }
          } else if (href.match('error')) {
            console.log('ERROR ', href);
            this.windowHandle.close();

          }
        }
      }
    }, this.intervalLength);
  }
  getLinkedInAccessToken(code: string) {
    const callable = httpsCallableData(this.fns,'getAccessToken');
    callable({ code: code, redirectUri: 'https://localhost:4200/authentication/linkedin/callback' }).subscribe(data => {
      console.log('FIRE FUNC REP ', data);
    });
  }

  createOauthWindow(width = 500, height = 600, left = 0, top = 0) {

    const options = `width=${width},height=${height},left=${left},top=${top}`;
    return this.window.open(this.authUrl, options);
  }
}
